document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', (context) => {
    return {
      context: context,
      itemsRoot: null,
      locked: null,
      items_section: '',
      sections: '',
      init() {
        if (context === 'drawer') {
          this.items_section = 'drawer-cart-items';
          this.sections =
            'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';
        } else {
          this.items_section = 'cart-items';
          this.sections =
            'cart-items,cart-items,cart-footer,cart-item-count,cart-live-region';
        }

        this.itemsRoot = this.$root;

        window.addEventListener('switch:cart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );
          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
          });
        });

        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          if (!this.itemsRoot.contains(e.detail.originalTarget)) return;

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );

          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
          }, 1000);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);

        const config = fetchConfigDefaults();

        let sections = this.sections;

        config.headers.Accept = 'application/javascript';

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                errorEl.textContent = data.message;

                errorEl.classList.remove('hidden');

                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;
                this.$el.dispatchEvent(new Event('input'));
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('switch:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      async removeSet(reference, event) {
        if (this.locked) return;
        const button = event?.currentTarget;
        const summary = button?.closest('[data-set-summary]');
        const errorEl = summary?.querySelector('[data-set-error]');
        const statusEl = summary?.querySelector('[data-set-status]');
        const members = Array.from(this.itemsRoot.querySelectorAll('li[data-cart-item-key][data-set-reference]'))
          .filter((item) => item.dataset.setReference === reference);

        if (!members.length) {
          if (errorEl) {
            errorEl.textContent = 'This set is no longer in your cart. Refresh the page to see the latest items.';
            errorEl.hidden = false;
          }
          return;
        }

        this.locked = summary || button;
        const originalText = button?.textContent;
        if (button) {
          button.disabled = true;
          button.textContent = 'Removing Set…';
        }
        if (summary) summary.setAttribute('aria-busy', 'true');
        if (errorEl) errorEl.hidden = true;
        if (statusEl) {
          statusEl.textContent = 'Removing all plinths in this set…';
          statusEl.hidden = false;
        }

        const updates = Object.fromEntries(members.map((item) => [item.dataset.cartItemKey, 0]));
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 20000);

        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ updates }),
            signal: controller.signal,
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not remove this set.');
          }
          if (Array.isArray(data.items) && data.items.some((item) => item.properties?.['Set reference'] === reference)) {
            throw new Error('Some plinths are still in your cart. Refresh the page and try again.');
          }
          if (statusEl) statusEl.textContent = 'Set removed. Updating your cart…';
          window.location.reload();
        } catch (error) {
          if (statusEl) statusEl.hidden = true;
          if (errorEl) {
            errorEl.textContent = error.name === 'AbortError'
              ? 'The cart is taking too long to respond. Refresh the page before trying again.'
              : (error.message || 'Could not remove this set. Please try again.');
            errorEl.hidden = false;
          }
        } finally {
          window.clearTimeout(timeout);
          if (summary) summary.removeAttribute('aria-busy');
          if (button) {
            button.disabled = false;
            button.textContent = originalText;
          }
          this.locked = null;
        }
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 0) {
            newValue = lastValue - 1;
          } else {
            newValue = 0;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
